import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  userInfo: null,
  diamondBankList: null, //- 鑽保銀行
  sliverBankList: null,  //- 銀保銀行
  pendingMessage: null,  //- 綁定審核文字
};

// getters
const getters = {};

// actions
const actions = {
  //- 帶入使用者 ＬＩＮＥ 資料
  index({commit}, data) {
    return new Promise(function(resolve) {
      commit('setUserInfo', data);
    });
  },
  //- 拿取鑽保銀行
  getDiamondBank({commit}){
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/bind/get-diamond-select-bank`)
      .then( res => {
        commit('setDiamondBankList', res.data);
      });
  },
  //- 拿取銀保銀行
  getSliverBank({commit}){
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/bind/get-sliver-select-bank`)
      .then( res => {
        commit('setSliverBankList', res.data);
      });
  },
  submit({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/bind/bind`, {
      params: data
    })
      .then( res => {
        return res;
      })
      .catch( err => {
        return err;
      });
  },
  checkIsPending({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/bind/is-pending`, {
      params: data
    })
      .then( res => {
        commit('setPendingMessage', res.data.message);
        return res;
      })
      .catch( err => {
        return err;
      });
  },
};

// mutations
const mutations = {
  //- 設定個人資料
  setUserInfo(state, data) {
    Vue.set(state, 'userInfo', data);
  },
  //- 設定鑽保銀行
  setDiamondBankList(state, data) {
    Vue.set(state, 'diamondBankList', data.data);
  },
  //- 設定銀保銀行
  setSliverBankList(state, data) {
    Vue.set(state, 'sliverBankList', data.data);
  },
  //- 設定綁定審核顯示文字
  setPendingMessage(state, data) {
    Vue.set(state, 'pendingMessage', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
